import { render, staticRenderFns } from "./giftGoods.vue?vue&type=template&id=8c743136&scoped=true"
import script from "./giftGoods.vue?vue&type=script&lang=js"
export * from "./giftGoods.vue?vue&type=script&lang=js"
import style0 from "./giftGoods.vue?vue&type=style&index=0&id=8c743136&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c743136",
  null
  
)

export default component.exports